// ZorgLink Landing Page JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // FAQ Accordion functionality with smooth animations
    const faqItems = document.querySelectorAll('.border.border-gray-200.rounded-lg');
    faqItems.forEach((item)=>{
        const questionContainer = item.querySelector('.flex.items-center.justify-between');
        const question = item.querySelector('h3');
        const answer = item.querySelector('.faq-answer');
        const expandIcon = item.querySelector('img');
        // Only add click functionality if there's an answer
        if (answer) {
            // Initially set up the answer for animations
            answer.style.maxHeight = '0';
            answer.style.opacity = '0';
            answer.style.overflow = 'hidden';
            answer.style.transition = 'max-height 0.4s ease-out, opacity 0.3s ease, padding 0.3s ease';
            answer.style.paddingTop = '0';
            answer.style.paddingBottom = '0';
            // Add click handler to the question container
            questionContainer.addEventListener('click', function() {
                const isOpen = answer.style.maxHeight !== '0px' && answer.style.maxHeight !== '';
                // Close all other FAQ items
                faqItems.forEach((otherItem)=>{
                    const otherAnswer = otherItem.querySelector('.faq-answer');
                    const otherIcon = otherItem.querySelector('img');
                    const otherQuestionContainer = otherItem.querySelector('.flex.items-center.justify-between');
                    if (otherAnswer && otherAnswer !== answer) {
                        // Close other item
                        otherAnswer.style.maxHeight = '0';
                        otherAnswer.style.opacity = '0';
                        otherAnswer.style.paddingTop = '0';
                        otherAnswer.style.paddingBottom = '0';
                        // Rotate icon back
                        if (otherIcon) {
                            otherIcon.style.transform = 'rotate(0deg)';
                            otherIcon.style.transition = 'transform 0.3s ease';
                        }
                        // Remove active state
                        otherItem.classList.remove('active');
                    }
                });
                // Toggle current item
                if (isOpen) {
                    // Close current item
                    answer.style.maxHeight = '0';
                    answer.style.opacity = '0';
                    answer.style.paddingTop = '0';
                    answer.style.paddingBottom = '0';
                    // Rotate icon
                    if (expandIcon) {
                        expandIcon.style.transform = 'rotate(0deg)';
                        expandIcon.style.transition = 'transform 0.3s ease';
                    }
                    // Remove active state
                    item.classList.remove('active');
                } else {
                    // Open current item
                    const scrollHeight = answer.scrollHeight;
                    answer.style.maxHeight = scrollHeight + 'px';
                    answer.style.opacity = '1';
                    answer.style.paddingTop = '0';
                    answer.style.paddingBottom = '0';
                    // Rotate icon
                    if (expandIcon) {
                        expandIcon.style.transform = 'rotate(180deg)';
                        expandIcon.style.transition = 'transform 0.3s ease';
                    }
                    // Add active state
                    item.classList.add('active');
                }
            });
        }
        // Add hover effect to question
        question.style.cursor = 'pointer';
    });
    // Smooth scrolling for anchor links
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach((link)=>{
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    });
    // Button click handlers
    const buttons = document.querySelectorAll('button');
    buttons.forEach((button)=>{
        button.addEventListener('click', function() {
            // Add click animation
            this.style.transform = 'scale(0.95)';
            setTimeout(()=>{
                this.style.transform = 'scale(1)';
            }, 150);
            // Handle specific button actions
            const buttonText = this.textContent.trim();
            if (buttonText.includes('Plan een gesprek') || buttonText.includes('Plan een gesprekje') || buttonText.includes('Contact')) // Open calendar link in a new tab
            window.open('https://calendar.app.google/cE7zGLscP2uPGSnj6', '_blank');
            else if (buttonText.includes('Meer weten')) {
                // Scroll to features section
                const featuresSection = document.querySelector('section:nth-of-type(3)');
                if (featuresSection) featuresSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            } else if (buttonText.includes('Mail ons')) // Open email client
            window.location.href = 'mailto:info@lemonade.be?subject=ZorgLink Inquiry';
        });
    });
    // Add scroll animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);
    // Observe sections for scroll animations
    const sections = document.querySelectorAll('section');
    sections.forEach((section)=>{
        section.style.opacity = '0';
        section.style.transform = 'translateY(20px)';
        section.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(section);
    });
    // Header scroll effect
    const header = document.querySelector('header');
    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', function() {
        const currentScrollY = window.scrollY;
        if (currentScrollY > 100) {
            header.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
            header.style.backdropFilter = 'blur(10px)';
            header.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.1)';
        } else {
            header.style.backgroundColor = 'white';
            header.style.backdropFilter = 'none';
            header.style.boxShadow = 'none';
        }
        lastScrollY = currentScrollY;
    });
    // Add loading animation
    window.addEventListener('load', function() {
        document.body.style.opacity = '0';
        document.body.style.transition = 'opacity 0.5s ease';
        setTimeout(()=>{
            document.body.style.opacity = '1';
        }, 100);
    });
    // Form validation (if contact forms are added)
    function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }
    // Add form validation to any forms
    const forms = document.querySelectorAll('form');
    forms.forEach((form)=>{
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const emailInput = form.querySelector('input[type="email"]');
            if (emailInput && !validateEmail(emailInput.value)) {
                alert('Please enter a valid email address.');
                return;
            }
            // Handle form submission
            console.log('Form submitted:', new FormData(form));
            alert('Thank you for your message! We will get back to you soon.');
        });
    });
    // Add keyboard navigation support
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') document.body.classList.add('keyboard-navigation');
    });
    document.addEventListener('mousedown', function() {
        document.body.classList.remove('keyboard-navigation');
    });
    // Performance optimization: Lazy load images
    const images = document.querySelectorAll('img');
    const imageObserver = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src || img.src;
                img.classList.remove('lazy');
                imageObserver.unobserve(img);
            }
        });
    });
    images.forEach((img)=>{
        if (img.dataset.src) imageObserver.observe(img);
    });
    console.log('ZorgLink landing page loaded successfully!');
});

//# sourceMappingURL=website.4299868e.js.map
